import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { RegisteredLoadingIndicator, RegisteredErrorInfo } from 'piral-core';
import { useForm } from './useForm';
import { usePromise } from './usePromise';
export function withForm(Component, options) {
    const FormView = (props) => {
        const formProps = useForm(props.initialData, props.history, options);
        return (React.createElement("form", { onSubmit: formProps.submit },
            React.createElement(Component, { ...props, ...formProps })));
    };
    const FormLoader = (props) => {
        const { loadData, emptyData } = options;
        const { loading, data, error } = usePromise(() => typeof loadData !== 'function' ? Promise.resolve(emptyData) : loadData(props));
        if (loading) {
            return React.createElement(RegisteredLoadingIndicator, null);
        }
        else if (data) {
            return React.createElement(FormView, { ...props, initialData: data });
        }
        else {
            return React.createElement(RegisteredErrorInfo, { type: "form", error: error });
        }
    };
    return withRouter(FormLoader);
}
//# sourceMappingURL=withForm.js.map